<template>
  <c-dialog ref="dialog" title="提现申请详情" mode="slide" width="500" enable-flex mask-close :button="false">
    <template #head>
      <div v-if="detailData.apply_no" class="m-detail-tag flex-center-cross">
          <c-state tag async dict="WITHDRAW_STATUS" :value="detailData.withdraw_status"></c-state>
          <label>{{detailData.apply_no}}</label>
      </div>
    </template>
    <c-detail class="m-detail-form">
          <c-detail-item label="提现申请单号">
              {{detailData.apply_no}}
          </c-detail-item>
          <c-detail-item label="提现状态">
              <c-state tag async dict="WITHDRAW_STATUS" :value="detailData.withdraw_status"></c-state>
          </c-detail-item>
          <c-detail-item label="打款方式">
              <template #default="{data}">
                  <c-state v-if="detailData.withdraw_pay_type == 0" tag async dict="WITHDRAW_PAY_TYPE" :value="detailData.withdraw_pay_type"></c-state>
                  <c-state v-else-if="detailData.withdraw_pay_type == 1" tag async dict="WITHDRAW_PAY_TYPE" :value="detailData.withdraw_pay_type"></c-state>
                  <span v-else>-</span>
              </template>
          </c-detail-item>
          <c-detail-item label="提现金额">
              ￥{{detailData.withdraw_amount}}
          </c-detail-item>
          <c-detail-item label="提现手续费">
              <template #default="{data}">
                  <span v-if="detailData.withdraw_fee && detailData.withdraw_fee > 0" style="color: red">
                      ￥{{detailData.withdraw_fee}}（商家承担）
                  </span>
                  <span v-else>￥{{detailData.withdraw_fee}}</span>
              </template>
          </c-detail-item>
          <c-detail-item label="预计到账">
              <template #default="{data}">
                  <span v-if="detailData.arrival_amount && detailData.arrival_amount > 0" style="color: green">
                      ￥{{detailData.arrival_amount}}
                  </span>
                  <span v-else>￥{{detailData.arrival_amount}}</span>
              </template>
          </c-detail-item>
          <c-detail-item label="提现银行">
              {{detailData.bank_name}}
          </c-detail-item>
          <c-detail-item label="提现卡号">
              {{detailData.bank_card_no}}
          </c-detail-item>
          <c-detail-item label="提现申请人">
              {{detailData.user_realname||'-'}}
          </c-detail-item>
          <c-detail-item label="提现申请时间">
              {{detailData.create_date||'-'}}
          </c-detail-item>
          <c-detail-item label="审批人">
              {{detailData.audit_user_realname||'-'}}
          </c-detail-item>
          <c-detail-item label="审批时间">
              {{detailData.audit_time||'-'}}
          </c-detail-item>
          <c-detail-item label="审批驳回原因" v-show="detailData.withdraw_status == 6">
              {{detailData.reject_reason||'-'}}
          </c-detail-item>
          <c-detail-item label="打款凭证" v-if="detailData.withdraw_pay_type == 0">
              <c-file  v-if="detailData.pay_voucher_img_url" :src="detailData.pay_voucher_img_url" media></c-file>
          </c-detail-item>
      </c-detail>
  </c-dialog>
</template>

<script>

export default {
  name: 'withdrawApplyDetail',

  components: {
  },

  props: {
    id: [String, Number]
  },

  data() {
    return {
        workType: 2,
        detailData: {},
        productList:[]
    }
  },

  computed: {
  },

  methods: {
    /**
     * 加载详情
     */
    detail(){
        this.request({
          url:'/withdraw/detail',
          data: {
            id: this.id
          },
          loading: true,
          success: data => {
            this.detailData = data.detailData;
            this.productList = data.productList||[];
          }
        });
    },
      /*********获取产品信息文字**********/
    getProductText(data) {
          var parts = [];
          if (data.brand_name) parts.push(data.brand_name);
          if (data.spu_model_name) parts.push(data.spu_model_name);
          if (data.color_name) parts.push(data.color_name);
          if (data.memory_name) parts.push(data.memory_name);
          return parts.join(' ') || '-';
      },

    open() {
        this.detail();
        this.$refs.dialog.open();
    }
  }
}
</script>

<style lang="stylus" scoped>
.logs-list {
  padding: 10px 10px;

  li {
    padding: 4px 0;
    line-height: 16px;
    font-size: 13px;
    color: #666;
  }
}
</style>